/* Cart drawer runtime (Phase 4, 2026-09-22). Replaces the Ecomus `hdt-cart-drawer`, `hdt-quantity-wrapp`,
   `hdt-cart-action` and `wrapp-remove-item-oncart` elements with ~120 lines that honour the §6.3 contract:
   - `<hdt-cart-drawer>` exposes open()/close(), `#CartDrawer` is a light-DOM <dialog> (showModal),
   - `cart:refresh` / `cart:reload` on document (or documentElement, they bubble) re-fetch `/?section_id=cart-drawer`
     and swap `.hdt-mini-cart__wrap`, then update every `hdt-cart-count`,
   - `[aria-controls="CartDrawer"]` toggles the drawer; `[aria-controls="<dialog id>"]` toggles a sheet inside it,
   - quantity +/- and the input inside `hdt-quantity-wrapp`, and `wrapp-remove-item-oncart`, write to /cart/change.js.
   assets/cart-drawer-custom.js (shared, unedited) owns note/discount/warranty/inline-edit and the fetch interceptor. */
(function () {
  var root = function () { return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'; };
  var json = { 'Content-Type': 'application/json' };

  class CartDrawer extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('#CartDrawer');
      if (this._bound) return;
      this._bound = true;
      if (!this.dialog) { /* inline mode: the /cart page renders the same contents without a dialog */
        var refreshInline = this.refresh.bind(this); document.addEventListener('cart:refresh', refreshInline); document.addEventListener('cart:reload', refreshInline); return;
      }
      this.dialog.addEventListener('click', function (e) { if (e.target === this.dialog) this.close(); }.bind(this));
      this.dialog.addEventListener('cancel', function (e) { e.preventDefault(); var sheet = this.dialog.querySelector('dialog[open]'); if (sheet) sheet.close(); else this.close(); }.bind(this));
      this.dialog.addEventListener('close', function () { document.body.classList.remove('rs-cart-open'); if (window.rsScrollLock) window.rsScrollLock('cart', false); this.error(''); }.bind(this));
      var refresh = this.refresh.bind(this);
      document.addEventListener('cart:refresh', refresh);
      document.addEventListener('cart:reload', refresh);
    }
    open() {
      if (!this.dialog) return;
      var was = this.dialog.open;
      if (!was) { try { this.dialog.showModal(); } catch (e) { this.dialog.setAttribute('open', ''); } }
      document.body.classList.add('rs-cart-open'); if (window.rsScrollLock) window.rsScrollLock('cart', true);
      /* After Add to Cart the drawer opens while its refresh is still in flight: count the items once it has landed. */
      if (!was) { var src = this._source || 'auto'; Promise.resolve(this._scheduled || this._pending).catch(function () {}).then(function () { var sum = cartSummary(); return cartId(sum.items).then(function (id) { track('cart_open', Object.assign({ source: src, cart: id }, sum)); }); }); }
      this._source = null;
    }
    close() {
      if (!this.dialog) return;
      var sheet = this.dialog.querySelector('dialog[open]'); if (sheet) sheet.close();
      if (this.dialog.open) this.dialog.close();
    }
    toggle() { if (!this.dialog) return; this.dialog.open ? this.close() : this.open(); }
    /* Coalesce bursts of events into one fetch; if a new request lands while one is in flight, fetch once more after it. */
    refresh() {
      if (this._pending) { this._again = true; return this._pending; }
      /* R-41 (2026-09-26): the shared script dispatches each event on documentElement and on document; both reach this
         listener in the same tick, so the fetch is started in a microtask and same-tick calls share it. */
      if (this._scheduled) return this._scheduled;
      var self0 = this;
      this._scheduled = Promise.resolve().then(function () { self0._scheduled = null; return self0._fetch(); });
      return this._scheduled;
    }
    _fetch() {
      if (this._pending) { this._again = true; return this._pending; }
      var self = this; var id = this.getAttribute('section-id') || 'cart-drawer';
      var wrap0 = this.querySelector('.hdt-mini-cart__wrap'); if (wrap0) wrap0.classList.add('is-updating'); /* R-39: stale 1-based indexes must not be clickable while the re-render is in flight */
      /* Inline mode (/cart page): the section is a template section, so it must be rendered on its own page. */
      var inline = this.hasAttribute('data-inline'); var base = inline ? location.pathname : root();
      this._pending = fetch(base + '?section_id=' + encodeURIComponent(id), { headers: { Accept: 'text/html' } })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('.hdt-mini-cart__wrap'); var cur = self.querySelector('.hdt-mini-cart__wrap');
          if (inline && !fresh) { location.reload(); return; } /* cart emptied: the empty state lives outside the wrap */
          if (fresh && cur) cur.innerHTML = fresh.innerHTML;
          syncWarranty(self);
          var el = doc.querySelector('hdt-cart-drawer'); var count = el && el.getAttribute('data-count');
          if (count != null) { self.setAttribute('data-count', count); document.querySelectorAll('hdt-cart-count').forEach(function (c) { c.textContent = count; c.setAttribute('aria-label', count + ' items in cart'); c.hidden = String(count) === '0'; }); }
        })
        .catch(function () {})
        .then(function () { self._pending = null; if (self._again) { self._again = false; return self._fetch(); } var w = self.querySelector('.hdt-mini-cart__wrap'); if (w) w.classList.remove('is-updating'); });
      return this._pending;
    }
    /* R-42 (2026-09-26): Shopify answers 422 with {description} when a quantity cannot be set (stock, sold out); show it. */
    error(text) {
      var box = this.querySelector('.rs-cart__error');
      if (!box && !text) return;
      if (!box) { box = document.createElement('p'); box.className = 'rs-cart__error'; box.setAttribute('role', 'alert'); var head = this.querySelector('.rs-cart__header'); if (head && head.parentNode) head.parentNode.insertBefore(box, head.nextSibling); else this.insertBefore(box, this.firstChild); }
      box.textContent = text || ''; box.hidden = !text;
    }
    change(body) {
      var wrap = this.querySelector('.hdt-mini-cart__wrap'); if (wrap) wrap.classList.add('is-updating');
      var self = this;
      return fetch(root() + 'cart/change.js', { method: 'POST', headers: json, body: JSON.stringify(body) })
        .then(function (r) { if (r.ok) { self.error(''); return; } return r.json().then(function (j) { self.error(j && (j.description || j.message) || 'This change could not be applied.'); }, function () { self.error('This change could not be applied.'); }); })
        .catch(function () { self.error('Connection problem. Please check your network and try again.'); })
        .then(function () { return self.refresh(); })
        .then(function () { if (wrap) wrap.classList.remove('is-updating'); });
    }
  }
  if (!customElements.get('hdt-cart-drawer')) customElements.define('hdt-cart-drawer', CartDrawer);
  /* Tags the shared snippet emits; defining them keeps the DOM valid and gives them element semantics. */
  ['hdt-quantity-wrapp', 'wrapp-remove-item-oncart', 'hdt-cart-count'].forEach(function (tag) {
    if (!customElements.get(tag)) customElements.define(tag, class extends HTMLElement {});
  });

  function drawer() { return document.querySelector('hdt-cart-drawer:not([data-inline])') || document.querySelector('hdt-cart-drawer'); }
  /* Warranty offer card: mirror the shared checkbox's state as a class, for browsers without CSS `:has()` (2026-09-26). */
  function syncWarranty(scope) {
    (scope || document).querySelectorAll('.rm-cart-addon-warranty').forEach(function (card) { var cb = card.querySelector('#rm-warranty-checkbox'); card.classList.toggle('is-checked', !!(cb && cb.checked)); });
  }
  document.addEventListener('change', function (e) { if (e.target && e.target.id === 'rm-warranty-checkbox') syncWarranty(); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { syncWarranty(); }); else syncWarranty();

  document.addEventListener('click', function (e) {
    var t = e.target.closest('[aria-controls]');
    if (t) {
      var id = t.getAttribute('aria-controls');
      if (id === 'CartDrawer') { var d = drawer(); if (!d || !d.dialog) return; e.preventDefault(); if (!d.dialog.open) d._source = 'cart_icon'; d.toggle(); return; }
      var target = document.getElementById(id);
      if (target && target.tagName === 'DIALOG' && target.closest('hdt-cart-drawer')) {
        e.preventDefault();
        if (target.open) target.close(); else { target.show(); var ta = target.querySelector('textarea, input'); if (ta) ta.focus(); }
        return;
      }
    }
    var remove = e.target.closest('wrapp-remove-item-oncart');
    if (remove) { e.preventDefault(); track('cart_remove', Object.assign({ line: parseInt(remove.dataset.index, 10), where: place(remove) }, lineInfo(remove))); var d2 = drawer(); if (d2) d2.change({ line: parseInt(remove.dataset.index, 10), quantity: 0 }); return; }
    var qbtn = e.target.closest('hdt-quantity-wrapp button');
    if (qbtn) {
      e.preventDefault();
      var input = qbtn.closest('hdt-quantity-wrapp').querySelector('input[type=number]'); if (!input) return;
      var min = parseInt(input.min, 10) || 0; var max = parseInt(input.dataset.max || input.max, 10) || 9999;
      var cur = parseInt(input.value, 10) || 0; var v = cur + (qbtn.name === 'plus' ? 1 : -1); v = Math.max(min, Math.min(max, v));
      if (v === cur) return; /* R-42: minus at the minimum (or plus at the maximum) posts nothing */
      input.value = v; track('cart_quantity', Object.assign({ line: parseInt(input.dataset.index, 10), from: cur, to: v, where: place(input) }, lineInfo(input)));
      var d3 = drawer(); if (d3) d3.change({ line: parseInt(input.dataset.index, 10), quantity: v });
    }
  });
  document.addEventListener('change', function (e) {
    var input = e.target.closest('hdt-quantity-wrapp input[type=number]'); if (!input) return;
    var v = Math.max(parseInt(input.min, 10) || 0, parseInt(input.value, 10) || 0);
    track('cart_quantity', Object.assign({ line: parseInt(input.dataset.index, 10), from: parseInt(input.getAttribute('value'), 10) || null, to: v, where: place(input) }, lineInfo(input)));
    var d = drawer(); if (d) d.change({ line: parseInt(input.dataset.index, 10), quantity: v });
  });

  /* First-party cart and checkout events (2026-09-29, CUSTOM_THEME §10U A): sent through the shared logger's
     RingmakerLogger.track to our own Render backend (one small POST per event; no marketing tag involved).
     Codes and option names only: note texts, names and e-mails are never sent. */
  function track(name, data) { try { if (window.RingmakerLogger && window.RingmakerLogger.track) window.RingmakerLogger.track(name, data || {}); } catch (e) {} }
  function place(el) { return el && el.closest && el.closest('hdt-cart-drawer[data-inline]') ? 'cart_page' : 'drawer'; }
  function lineInfo(el) {
    var row = el && el.closest && el.closest('.hdt-cart-item'); var a = row && row.querySelector('a[href*="/products/"]');
    var m = a && (a.getAttribute('href') || '').match(/\/products\/([^/?#]+)/);
    return { product: m ? m[1].slice(0, 120) : null, warranty: !!(row && row.classList.contains('is-crafter-warranty-item')) };
  }
  /* §10V item 3 (Mike 2026-10-02): the cart's id in our own log, so a design can be followed to its exact order or abandoned
     checkout (orders carry the same id as cart_token). Only the part before "?key=" (the key opens the cart and never leaves
     the browser). One /cart.js read per drawer opening with items, 3 s at most; the shared logger's next design log sends it too. */
  var cartIdFor = -1, cartIdP = null;
  function cartId(items) {
    if (!items) return Promise.resolve(window.RM_CART_TOKEN || null);
    if (cartIdP && cartIdFor === items) return cartIdP;
    cartIdFor = items;
    cartIdP = Promise.race([
      fetch(root() + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
        var id = String((c && c.token) || '').split('?')[0].replace(/[^A-Za-z0-9_-]/g, '').slice(0, 64) || null;
        if (id) { window.RM_CART_TOKEN = id; try { sessionStorage.setItem('rs-cart-id', id); } catch (e) {} } return id;
      }),
      new Promise(function (ok) { setTimeout(function () { ok(window.RM_CART_TOKEN || null); }, 3000); })
    ]).catch(function () { cartIdP = null; return window.RM_CART_TOKEN || null; });
    return cartIdP;
  }
  /* Each page load resets RM_CART_TOKEN (the designer blocks print it empty), and the server keeps only the last design log's
     value: carry the id over from earlier in this tab while the cart still has items, so a later page does not blank it. */
  (function restoreCartId() {
    var d = document.querySelector('hdt-cart-drawer'); var n = d ? parseInt(d.getAttribute('data-count'), 10) || 0 : 0;
    try { if (!n) sessionStorage.removeItem('rs-cart-id'); else if (!window.RM_CART_TOKEN) window.RM_CART_TOKEN = sessionStorage.getItem('rs-cart-id') || null; } catch (e) {}
  })();
  /* §10V item 4 (Mike 2026-10-02): where a visit came from, once per browser tab, on the page it started on: the ad tags already
     in the link (utm_*), the referring site's name, and only whether an ad click id was present (never the id itself). Lets the
     conversion report give an order rate per channel. Sent after the page has loaded (or when it is left before that). */
  (function landing() {
    try { if (sessionStorage.getItem('rs-landing')) return; sessionStorage.setItem('rs-landing', '1'); } catch (e) { return; }
    var q, ref = '';
    try { q = new URL(location.href).searchParams; } catch (e) { return; }
    try { ref = document.referrer ? new URL(document.referrer).hostname : ''; } catch (e) {}
    if (ref && ref === location.hostname) ref = 'self';
    function pick(k) { return (q.get(k) || '').slice(0, 80) || null; }
    var data = { source: pick('utm_source'), medium: pick('utm_medium'), campaign: pick('utm_campaign'), content: pick('utm_content'), ref: ref.slice(0, 80) || null,
      path: (location.pathname || '').slice(0, 120), fb_click: q.has('fbclid'), google_ads: q.has('gclid') || q.has('gbraid') || q.has('wbraid') || q.has('gad_source'),
      google_shopping: q.has('srsltid'), klaviyo: q.has('_kx') };
    var done = false; function send() { if (!done) { done = true; track('landing', data); } }
    if (document.readyState === 'complete') setTimeout(send, 1500); else window.addEventListener('load', function () { setTimeout(send, 1500); }, { once: true });
    window.addEventListener('pagehide', send, { once: true });
  })();
  function cartSummary() {
    var d = drawer(); var total = document.querySelector('[data-er-cart-total-price]');
    return { items: d ? (parseInt(d.getAttribute('data-count'), 10) || 0) : null, total: total ? total.textContent.trim().slice(0, 20) : null };
  }
  document.addEventListener('change', function (e) {
    var sel = e.target; if (!sel || !sel.classList || !sel.classList.contains('rm-property-edit-select')) return;
    var via = sel.getAttribute('data-rs-via') || 'dropdown'; sel.removeAttribute('data-rs-via');
    track('cart_edit', Object.assign({ option: (sel.getAttribute('data-prop') || '').slice(0, 40), to: String(sel.value).slice(0, 60), via: via, where: place(sel) }, lineInfo(sel)));
  });
  /* The shared script stops warranty clicks in the capture phase on document, so this listens on window first. */
  window.addEventListener('click', function (e) {
    var t = e.target; if (!t || !t.closest) return;
    if (!t.closest('.rm-cart-addon-warranty, label[for="rm-warranty-checkbox"], #rm-warranty-custom-box, #rm-warranty-checkbox')) return;
    if (t.closest('a') || t.closest('details')) return;
    var cb = document.getElementById('rm-warranty-checkbox'); if (!cb) return;
    track('warranty_toggle', { added: t === cb ? cb.checked : !cb.checked, where: place(cb) });
  }, true);
  document.addEventListener('click', function (e) {
    var t = e.target; if (!t || !t.closest) return;
    var apply = t.closest('#rm-apply-discount-btn'); var removeBtn = apply ? null : t.closest('#rm-remove-discount-btn');
    var checkout = t.closest('.rs-cart__checkout'); var note = t.closest('#rm-cart-note-save-btn');
    if (checkout) { track('checkout_click', Object.assign({ source: place(checkout), cart: window.RM_CART_TOKEN || null }, cartSummary())); return; }
    if (note) { var ta = document.getElementById('Cart-note'); track('note_save', { length: ta ? ta.value.trim().length : 0, where: place(note) }); return; }
    if (!apply && !removeBtn) return;
    var input = document.getElementById('rm-discount-input'); var code = input ? input.value.trim().toUpperCase().slice(0, 40) : '';
    if (removeBtn) { track('discount_remove', { code: code, where: place(removeBtn) }); return; }
    if (!code) return;
    /* The shared script decides "applied" or "doesn't apply"; read its answer once the button is no longer busy. */
    var where = place(apply), tries = 0;
    setTimeout(function wait() {
      var btn = document.querySelector('#rm-apply-discount-btn, #rm-remove-discount-btn'); var msg = document.querySelector('.rm-discount-msg');
      var text = msg && !msg.hidden ? msg.textContent : '';
      if (!(btn && btn.getAttribute('aria-busy') === 'true') && text) { track('discount_apply', { code: code, result: text.indexOf('\u2713') === 0 ? 'applied' : 'rejected', where: where }); return; }
      if (++tries > 40) { track('discount_apply', { code: code, result: 'unknown', where: where }); return; }
      setTimeout(wait, 300);
    }, 300);
  });
  if (document.querySelector('hdt-cart-drawer[data-inline]')) { var pv = cartSummary(); cartId(pv.items).then(function (id) { track('cart_page_view', Object.assign({ cart: id }, pv)); }); }
})();
